import { PrimitiveDataFactory } from "@amzn/ask-legal-domain";

export const USER_SESSION_WINDOW = 1000 * 60 * 30; // 30 mins

export interface SessionCookies {
    sid?: string;
    sts?: number;
}

export interface SessionManager {
    setCookies: (name: string, value: any, options?: any) => void;
}

/**
 * Updates or creates a user session
 * @param cookies - Current cookies object containing sid and sts
 * @param sessionManager - Object with setCookies function to manage cookies
 * @returns sessionId - Current or new session ID
 */
export const updateSession = (
    cookies: SessionCookies,
    sessionManager: SessionManager
): string => {
    sessionManager.setCookies("sts", Date.now(), { path: "/" });
    if (
        !!cookies.sts
        && !!cookies.sid
        && (Date.now() - (cookies.sts as number) <= USER_SESSION_WINDOW)
    ) {
        return cookies.sid;
    }
    const sessionId = PrimitiveDataFactory.id();
    sessionManager.setCookies("sid", sessionId, { path: "/" });
    return sessionId;
};
